export const esBanks = {
  'banks.appliedChanges': '{count} cambios bancarios aplicados.',
  'banks.back': 'Volver a Cuenta',
  'banks.connect': 'Conectar banco',
  'banks.connectError': 'Plaid no pudo iniciar la conexión. Inténtalo nuevamente.',
  'banks.connected': 'Bancos conectados',
  'banks.connections': 'Conexiones bancarias',
  'banks.currency':
    'FinanceGo opera en USD; movimientos de otras monedas se omiten para no mezclar saldos.',
  'banks.description':
    'Conecta instituciones de Estados Unidos con Plaid para importar movimientos.',
  'banks.disconnect': 'Desconectar',
  'banks.empty': 'Aún no hay bancos conectados',
  'banks.emptyDescription':
    'Conecta uno para crear sus wallets e importar movimientos automáticamente.',
  'banks.keep': 'Conservar',
  'banks.lastSync': 'Última sincronización: {date}',
  'banks.loadError': 'No pudimos cargar tus conexiones bancarias.',
  'banks.memberVisibility':
    'Las wallets y movimientos importados son visibles para los miembros activos de tu cuenta compartida.',
  'banks.notManageable':
    'Esta conexión pertenece a otro miembro de la cuenta. Sólo esa persona puede administrarla.',
  'banks.notSynced': 'Sin sincronizar',
  'banks.requiresAttention': 'Requiere atención',
  'banks.safety': 'FinanceGo no te pide usuario ni contraseña del banco.',
  'banks.safetyTitle': 'Conecta tus bancos sin compartir tu contraseña.',
  'banks.sync': 'Sincronizar',
  'banks.title': 'Tus cuentas, dentro de tu plan.',
} as const;

export const enBanks: Record<keyof typeof esBanks, string> = {
  'banks.appliedChanges': '{count} bank changes applied.',
  'banks.back': 'Back to Account',
  'banks.connect': 'Connect bank',
  'banks.connectError': 'Plaid could not start the connection. Try again.',
  'banks.connected': 'Connected banks',
  'banks.connections': 'Bank connections',
  'banks.currency':
    'FinanceGo operates in USD; movements in other currencies are omitted to avoid mixing balances.',
  'banks.description': 'Connect United States institutions with Plaid to import movements.',
  'banks.disconnect': 'Disconnect',
  'banks.empty': 'No banks connected yet',
  'banks.emptyDescription': 'Connect one to create its wallets and import movements automatically.',
  'banks.keep': 'Keep',
  'banks.lastSync': 'Last sync: {date}',
  'banks.loadError': 'We could not load your bank connections.',
  'banks.memberVisibility':
    'Imported wallets and movements are visible to active members of your shared account.',
  'banks.notManageable':
    'This connection belongs to another account member. Only that person can manage it.',
  'banks.notSynced': 'Not synced',
  'banks.requiresAttention': 'Needs attention',
  'banks.safety': 'FinanceGo does not ask for your bank username or password.',
  'banks.safetyTitle': 'Connect banks without sharing your password.',
  'banks.sync': 'Sync',
  'banks.title': 'Your accounts, inside your plan.',
};
